import React from "react";
import { APP_STATUS_LABEL } from "@/lib/constants";

const TONE = {
  pending: "bg-amber-50 text-amber-800 border-amber-200",
  accepted: "bg-emerald-50 text-emerald-700 border-emerald-200",
  rejected: "bg-rose-50 text-rose-700 border-rose-200",
};

export default function StatusBadge({ status, testId }) {
  return (
    <span data-testid={testId}
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border ${TONE[status] || "bg-slate-100 text-slate-700"}`}>
      {APP_STATUS_LABEL[status] || status}
    </span>
  );
}
